import { useThemeContext } from '@huggg/react-components';
import { brandedDictionary } from 'utilities/recipientBranding';

// Sangria copy keyed on the theme's operator (Huggg or Post Office).
export default () => brandedDictionary(useThemeContext().operator);
